var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterEmailUsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 31.25 22.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;filter:url(#Shadow_3);}"), /*#__PURE__*/React.createElement("filter", {
    id: "Shadow_3",
    x: "-15%",
    y: "-15%",
    width: "140%",
    height: "130%",
    name: "Shadow_3"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    result: "offsetBlurredAlpha",
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "offsetBlurredAlpha"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.09,3.42H7.54A2.86,2.86,0,0,0,4.69,6.28V23.37a2.86,2.86,0,0,0,2.85,2.85H33.09a2.86,2.86,0,0,0,2.85-2.85V6.28A2.87,2.87,0,0,0,33.09,3.42Zm.44,6.12V22.18L26,15.62l6-6.1,1.61-1.66ZM32.15,5.82,28.6,9.47l-5.12,5.25h0a1.07,1.07,0,0,0-.19.18l-.05.06-1.08,1.12a2.21,2.21,0,0,1-1.57.65A2.19,2.19,0,0,1,19,16.08l-1.37-1.39a.08.08,0,0,0,0,0,1.14,1.14,0,0,0-.16-.15l0,0L12.35,9.24,9,5.82ZM7.09,22.08V9.17h0V7.3L8.94,9.19l6,6.17Zm9.54-5,.67.68a4.6,4.6,0,0,0,6.57,0l.4-.4,7.47,6.45h-23Z",
    transform: "translate(-4.69 -3.42)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterEmailUsIcon);
export default __webpack_public_path__ + "static/media/footerEmailUsIcon.5db1c9964c1a9950f62067b9eea8f482.svg";
export { ForwardRef as ReactComponent };